import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type {
  DecoratedUser,
  UndecoratedUser,
} from '@flemingmetrics/api-client';

type UsersState = {
  byId: Record<string, UndecoratedUser>;
};

const initialState: UsersState = { byId: {} };

export const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    addUser: (state, action: PayloadAction<DecoratedUser>) => {
      return getNextState(state, [action.payload]);
    },
    setUsers: (state, action: PayloadAction<DecoratedUser[]>) => {
      return getNextState(state, action.payload);
    },
    deleteUser: (state, action: PayloadAction<{ userId: number }>) => {
      delete state.byId[`${action.payload.userId}`];
    },
  },
});

function formatUser({ profile, ...user }: DecoratedUser): UndecoratedUser {
  return user;
}

function getNextState(state: UsersState, users: DecoratedUser[]) {
  const byId = { ...state.byId };
  users.forEach((user) => {
    byId[user.id] = formatUser(user);
  });
  return { byId };
}

export const { addUser, setUsers, deleteUser } = usersSlice.actions;

export default usersSlice.reducer;
